<template>
  <div id="app">
    <AppHeader v-if="$route.name && $route.name.indexOf('login') === -1" />

    <keep-alive include="Home">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isReloadAlive"></router-view>

    <AppBottom v-if="$route.name && $route.name.indexOf('login') === -1" />

    <DialogAgreement
      v-if="$route.name && $route.name.indexOf('login') === -1"
      ref="DialogAgreementRef"
    />
  </div>
</template>

<script>
import AppHeader from './layout/app-header.vue'
import AppBottom from './layout/app-bottom.vue'
import ls from '@/utils/localStorage'
import DialogAgreement from './components/DialogAgreement.vue'
import { Message } from 'element-ui'

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
    }
  },
  data: function() {
    return {
      isReloadAlive: true,
      isShowHB: this.$route.name && this.$route.name.indexOf('login') === -1,
    }
  },
  components: {
    AppHeader,
    AppBottom,
  },
  methods: {
    reload() {
      this.isReloadAlive = false
      this.$nextTick(function() {
        this.isReloadAlive = true
      })
    },

    handleAgreement() {
      const isAgreement = ls.get('isAgreement') || false
      if (isAgreement) return
      if (this.$route.name && this.$route.name.indexOf('login') !== -1) return
      this.$refs.DialogAgreementRef.handleShow()
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.handleAgreement()
    }, 1000)
  },
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  line-height: 1;
}
#app {
  width: 100%;
  overflow-x: hidden;
}
.daohang {
  width: 100%;
  height: 0.6rem;
  background-color: red;
}
</style>
